// providers/cloudfront.ts
import { createOperationsGenerator } from '#image'

export const getImage = (src: string, { modifiers }: any) => {
    const width = modifiers.width || 800
    return {
        url: `${src}?width=${width}`
    }
}

export const getImageMeta = () => undefined

export const operationsGenerator = createOperationsGenerator({
    keyMap: {
        width: 'width'
    },
    joinWith: '&',
    formatter: (key, value) => `${key}=${value}`
})
